import "./App.css";
import "./fonts/fonts.css";
import Navigation from "./main/navigation";
import { I18nextProvider } from "react-i18next";
import i18n from "./locales/i18n";

function App() {
	return (
		<I18nextProvider i18n={i18n}>
			<Navigation />
		</I18nextProvider>
	);
}

export default App;
